var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "40px",
    viewBox: "0 0 90 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "marker copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker-copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,0 C69.8525,0 90,20.1475 90,45 C90,66.735 74.5925,84.87 54.105,89.0775 L45,100 L35.9,89.08 C15.4075,84.87 0,66.735 0,45 C0,20.1475 20.1475,0 45,0 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,0 C69.8525,0 90,20.1475 90,45 C90,66.735 74.5925,84.87 54.105,89.0775 L45,100 L35.9,89.08 C15.4075,84.87 0,66.735 0,45 C0,20.1475 20.1475,0 45,0 Z",
    id: "Path",
    fill: "#25B676"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1);
export default __webpack_public_path__ + "static/media/m1.b10d1a19c2240f71956e19a0fa464a50.svg";
export { ForwardRef as ReactComponent };